/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LayoutMetadataChange
 */
export interface LayoutMetadataChange {
    /**
     * 
     * @type {string}
     * @memberof LayoutMetadataChange
     */
    fieldName: string;
    /**
     * The value - can be a string, object
     * @type {string | object}
     * @memberof LayoutMetadataChange
     */
    oldValue?: string | object;
    /**
     * The value - can be a string, object
     * @type {string | object}
     * @memberof LayoutMetadataChange
     */
    newValue?: string | object;
    /**
     * 
     * @type {string}
     * @memberof LayoutMetadataChange
     */
    changeType: LayoutMetadataChangeChangeTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LayoutMetadataChangeChangeTypeEnum {
    ADDED = 'ADDED',
    REMOVED = 'REMOVED',
    MODIFIED = 'MODIFIED',
    MOVED = 'MOVED',
    UNCHANGED = 'UNCHANGED'
}



